import tokens from '@ifood/pomodoro-tokens';

let div: HTMLDivElement;

const toHex = (value: string): string => parseInt(value).toString(16).toUpperCase().padStart(2, '0');

const toHexColor = (value: string): string => {
  const matches = value.match(/\((\d+),\s*(\d+),\s*(\d+)\)/);
  if (!matches) {
    return '#000000';
  }

  const [, r, g, b] = matches;

  return `#${toHex(r)}${toHex(g)}${toHex(b)}`;
};

const getTempDiv = (): HTMLDivElement => {
  if (div) return div;
  div = document.createElement('div');
  div.style.display = 'none';
  document.body.insertAdjacentElement('beforeend', div);
  return div;
};

export const parseCssColor = (str: string): string => {
  const div = getTempDiv();
  div.style.color = str;
  return toHexColor(getComputedStyle(div).color);
};

const VALID_3_DIGIT_HEX = /^#([A-F\d]{3})$/i;
const VALID_6_DIGIT_HEX = /^#([A-F\d]{6})$/i;

export const DEFAULT_COLOR = tokens.colors.primary;

export const sanitizeHex = (str: string): string => {
  if (VALID_3_DIGIT_HEX.test(str)) {
    return str;
  }

  if (VALID_6_DIGIT_HEX.test(str)) {
    return str;
  }

  return DEFAULT_COLOR;
};
